import { makeAutoObservable, runInAction } from 'mobx';

import { MIN_ANNUAL_AREA_AMOUNTS } from '../../../shared/helpers/constants/areaAmounts';
import type { IRootStore } from '../rootStore/RootStore';

export default class UiStateStore {
  rootStore: IRootStore;

  annualPlan: {
    area: string;
    additionalSeats: string;
    planetImagery: string;
  };

  constructor(rootStore: IRootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;

    this.annualPlan = {
      area: MIN_ANNUAL_AREA_AMOUNTS[
        this.rootStore.areaUnitStore.areaUnit
      ].toString(),
      additionalSeats: '0',
      planetImagery: '0',
    };
  }

  get annualPlanValid() {
    const minAreaAmount =
      MIN_ANNUAL_AREA_AMOUNTS[this.rootStore.areaUnitStore.areaUnit];

    const area = parseInt(this.annualPlan.area, 10);

    return area >= minAreaAmount;
  }

  reset() {
    runInAction(() => {
      this.annualPlan = {
        area: MIN_ANNUAL_AREA_AMOUNTS[
          this.rootStore.areaUnitStore.areaUnit
        ].toString(),
        additionalSeats: '0',
        planetImagery: '0',
      };
    });
  }

  setAnnualPlanArea = (area: string) => {
    this.annualPlan.area = area;
  };

  setAnnualPlanSeats = (additionalSeats: string) => {
    this.annualPlan.additionalSeats = additionalSeats;
  };

  setAnnualPlanPlanetImagery = (planetImagery: string) => {
    this.annualPlan.planetImagery = planetImagery;
  };
}
